/**
 * Haptic feedback utilities for mobile devices
 */

type HapticType = 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error';

export const triggerHaptic = (type: HapticType = 'light') => {
  // Check if device supports haptics
  if (!('vibrate' in navigator)) return;

  const patterns: Record<HapticType, number | number[]> = {
    light: 10,
    medium: 20,
    heavy: 30,
    success: [10, 50, 10],
    warning: [30, 50, 30],
    error: [50, 100, 50],
  };

  try {
    navigator.vibrate(patterns[type]);
  } catch (error) {
    console.warn('Haptic feedback not supported:', error);
  }
};

// Specific haptic helpers
export const haptics = {
  tap: () => triggerHaptic('light'),
  select: () => triggerHaptic('medium'),
  impact: () => triggerHaptic('heavy'),
  success: () => triggerHaptic('success'),
  warning: () => triggerHaptic('warning'),
  error: () => triggerHaptic('error'),
};
